/**
 * toFixed helper function
 * @param {any} value value
 * @param {any} decimals - The decimals
 * @returns {string} string
 */
function ToFixedValue(value: string | number | undefined | null, decimals: number = 2) {
  if (value == null || Number.isNaN(value)) {
    return '0.00';
  }
  const number = Number(value);
  const factor = 10 ** decimals;
  return (Math.trunc(number * factor) / factor).toFixed(decimals);
}

export default ToFixedValue;
